import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountsModule } from '../accounts/accounts.module';
import { SpendChangeBannerModule } from '../spend-change-requests/spend-change-banner/spend-change-banner.module';
import { GlobalAlertsComponent } from './global-alerts.component';

@NgModule({
  declarations: [GlobalAlertsComponent],
  imports: [CommonModule, AccountsModule, SpendChangeBannerModule],
  exports: [GlobalAlertsComponent],
})
export class GlobalAlertsModule {}
